import { useFlag } from '@/features/unleash';
import { NarrativeCommunitySpotlight } from './NarrativeCommunitySpotlight';

export const FlaggedNarrativeCommunitySpotlight = () => {
  const { flagsReady, enabled } = useFlag({
    name: 'mono-community-spotlight',
  });

  if (flagsReady && enabled) {
    return <NarrativeCommunitySpotlight />;
  }

  return null;
};
